import { IIcon, MuiIcons } from './types';

const Icon: React.FC<IIcon> = ({ iconName, size, ...rest }) => {
  const IconComponent = MuiIcons[iconName];

  return <IconComponent {...rest} sx={{ fontSize: size }} />;
};
export default Icon;
